/**
 * Atlas PM · 操作日志（系统设置标签内容）
 *
 * P6.35：用户可见入口文案由「审计日志」更名为「操作日志」，
 * 权限码 `audit:view`、路由 `/settings/audit` 与数据语义均保持不变。
 *
 * 与独立页 /audit 共用 AuditLogView。
 * 系统设置容器已提供页头，此处不再重复标题。
 */

import AuditLogView from './AuditLogView';

export default function AuditPanel() {
  return <AuditLogView />;
}
